import { createCommunicationColumns } from "./communication-table-helper";
import {
  buildCommunicationLogisticsPreview,
  buildCommunicationOrderPreview,
  buildCommunicationQuestionPreview,
  formatCommunicationPreviewDate,
} from "./communication-preview-helper";
import {
  getCommunicationConfidenceTone,
  normalizeCommunicationConfidence,
} from "./communication-confidence-helper";
import { buildCommunicationTaskSteps } from "./communication-step-helper";
import { formatCommunicationStandNumberLabel } from "./communication-stand-format-helper";
import { useCommunicationAutoRefresh } from "./communication-auto-refresh-helper";
import {
  buildCommunicationIncomingWhere,
  buildCommunicationTaskDigestSignature,
  getCommunicationServerOrderBy,
  getCommunicationSummary,
  shouldLoadFullCommunicationTaskSet,
  getTaskStatusFromValues,
  useCommunicationStore,
} from "./communication-store";

const CommunicationHelpers = {
  createCommunicationColumns,
  buildCommunicationOrderPreview,
  buildCommunicationQuestionPreview,
  buildCommunicationLogisticsPreview,
  getCommunicationConfidenceTone,
  buildCommunicationTaskSteps,
  formatCommunicationStandNumberLabel,
  formatCommunicationPreviewDate,
  normalizeCommunicationConfidence,
  useCommunicationAutoRefresh,
  useCommunicationStore,
  buildCommunicationIncomingWhere,
  buildCommunicationTaskDigestSignature,
  getCommunicationServerOrderBy,
  shouldLoadFullCommunicationTaskSet,
  getCommunicationSummary,
  getTaskStatusFromValues,
};

export default CommunicationHelpers;

export * from "./communication-types-helper";
export * from "./communication-confidence-helper";
export * from "./communication-step-helper";
export * from "./communication-stand-format-helper";
export * from "./communication-auto-refresh-helper";
